import { render, staticRenderFns } from "./GrantRegistry.vue?vue&type=template&id=ab724ac0&scoped=true&"
import script from "./GrantRegistry.vue?vue&type=script&lang=js&"
export * from "./GrantRegistry.vue?vue&type=script&lang=js&"
import style0 from "./GrantRegistry.vue?vue&type=style&index=0&id=ab724ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab724ac0",
  null
  
)

export default component.exports